import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import Button from "./Button";
import ModalWindow from "../widgets/ModalWindow";
import Select from "../widgets/Select";
import {useApi} from "../ApiSession";

const isValidFileName = f => {
    if (f === "" || f === null) {
        return true
    }
    const re = /^[A-Za-z0-9_\-]+$/
    return re.test(f)
}


export default () => {

    const [pipelineTypes, setPipelineTypes] = useState([])

    const [pipelineType, setPipelineType] = useState()

    const [pipelineInstanceName, setPipelineInstanceName] = useState(null)

    const [nameIsInvalid, setNameInvalid] = useState(null)

    const [nameAlreadyExists, setNameAlreadyExists] = useState(null)

    const navigate = useNavigate()

    const api = useApi()

    const showInvalidWarning =
        nameIsInvalid !== null && nameIsInvalid

    const showNameAlreadyExists =
        nameAlreadyExists !== null && nameAlreadyExists

    const canCreate = pipelineInstanceName !== null && !showNameAlreadyExists && !showInvalidWarning

    useEffect(() => {
        api.getPipelineTypes().then(res => {
            setPipelineTypes(res)
            setPipelineType(res[0])
        })
    }, []);

    useEffect(() => {

        setNameInvalid(!isValidFileName(pipelineInstanceName))

        if (pipelineInstanceName != null && pipelineInstanceName !== "") {
            api.getPipelineInstanceExists(pipelineType, pipelineInstanceName).then(setNameAlreadyExists)
        }

    }, [pipelineInstanceName])

    const create = () => {
        api.createNewPipeline(
            pipelineType.instances_dir_basename,
            pipelineInstanceName,
            pipelineType.default_args
        ).then(result =>
            navigate(`/pipelines${result.pid}`)
        )
    }


    const body = () => <div className="p-4 md:p-5 space-y-4">
                <div className="max-w-sm mx-auto">
                    <Select
                        label={"Pipeline Type"}
                        value={pipelineType && pipelineType.name || ''}
                        onChange={e =>
                            setPipelineType(pipelineTypes.find(pt => pt.name === e.target.value))
                        }
                    >
                        {
                            pipelineTypes.map(pt =>
                                <option key={pt.name} value={pt.name}>
                                    {pt.name}
                                </option>
                            )
                        }
                    </Select>
                </div>
                <div className="max-w-sm mx-auto">
                    <label
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                        Pipeline Name (use only letters, numbers, "_", and "-")
                    </label>
                    <input type="text"
                           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                           value={pipelineInstanceName || ''}
                           onChange={e => setPipelineInstanceName(e.target.value)}
                    />

                    {
                        showInvalidWarning &&
                        <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                            Invalid name, must contain only letters, numbers, "_", and "-".
                        </p>
                    }
                    {
                        showNameAlreadyExists &&
                        <p className="mt-2 text-sm text-red-600 dark:text-red-500">
                            Already Exists
                        </p>
                    }

                </div>
            </div>

    const cancel = () => navigate("/")

    return <ModalWindow
        title={"Create New Pipeline Instance"}
        marginTop={100}
        onClose={cancel}
        footer={<>
                <Button
                    caption={"Create"}
                    onClick={create}
                    disabled={!canCreate}
                />
                <button
                    type="button"
                    onClick={cancel}
                    className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                >Cancel
                </button>
        </>}
    >
        {body()}
    </ModalWindow>
}
